import React from 'react';
import { LayoutGrid, ShieldAlert, Kanban, Users } from 'lucide-react';
import { i18n } from '../../../../i18n/index.js';

export interface LobeEntityFeedProps {
  title?: string | undefined;
  icon?: React.ReactNode | undefined;
  count?: number | undefined;
  payloadType?: 'deal_risk' | 'deal' | 'contact' | undefined;
  children: React.ReactNode;
}

export function LobeEntityFeed({
  title,
  icon,
  count,
  payloadType,
  children,
}: LobeEntityFeedProps): React.ReactElement {
  const defaultIcon =
    payloadType === 'deal_risk' ? (
      <ShieldAlert size={14} className="text-zinc-600" />
    ) : payloadType === 'deal' ? (
      <Kanban size={14} className="text-zinc-600" />
    ) : payloadType === 'contact' ? (
      <Users size={14} className="text-zinc-600" />
    ) : (
      <LayoutGrid size={14} className="text-zinc-500" />
    );

  return (
    <div
      data-testid="lobe-entity-feed"
      className="my-2 overflow-hidden rounded-xl border border-zinc-200/80 bg-white shadow-2xs transition-all hover:border-zinc-300"
    >
      {/* LobeHub Minimal Monochrome Header */}
      {title && (
        <div className="flex items-center justify-between border-b border-zinc-100 bg-zinc-50/70 px-3.5 py-2 text-xs">
          <div className="flex items-center gap-2">
            {icon ?? defaultIcon}
            <span className="font-semibold text-zinc-900">{title}</span>
            {count !== undefined && (
              <span className="inline-flex items-center rounded-full bg-zinc-200/70 px-1.5 py-0.2 text-[10px] font-medium text-zinc-600">
                {count}
              </span>
            )}
          </div>
          <span className="text-[11px] font-normal text-zinc-400">
            {i18n.t('crm.snippets.entity_feed.row_hint')}
          </span>
        </div>
      )}

      {/* High-Density Row List */}
      <div className="divide-y divide-zinc-100 bg-white">{children}</div>
    </div>
  );
}
